// extracted by mini-css-extract-plugin
export default {"noticeContainer":"Jf4jH","newNotice":"YcO4Q","noticeBody":"LNnMA","infoGroup":"PSU2M","userNickname":"_1-lxZ","commentDate":"GCvo5","recordText":"qQq9J","post":"oocW+"};